<template>
  <div class="content">
    <el-card>
      <el-form class="form_pad" ref="formPad" :inline="true" :model="listQuery">
        <el-row class="clear_fix">
          <el-form-item :label="$t('table.coMode')">
            <el-select
              v-model="listQuery.co_mode"
              clearable
              filterable
              style="width: 140px"
              :placeholder="$t('common.selectMode')"
            >
              <el-option
                v-for="(item, index) in $com.abroadList.modeList"
                :key="item.id"
                :label="$i18n.locale == 'zh' ? item.name : item.en_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('table.application')">
            <el-select
              v-model="listQuery.application_id"
              clearable
              filterable
              style="width: 140px"
              :placeholder="$t('common.selectApp')"
            >
              <el-option
                v-for="(item, index) in appList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('sdk.flowType')">
            <el-select
              v-model="listQuery.flow_type"
              clearable
              filterable
              :placeholder="$t('common.selectFlowType')"
              style="width: 140px"
            >
              <el-option
                v-for="item in [
                  ...$com.abroadList.flowTypeOpenAd,
                  ...$com.abroadList.flowTypeList,
                ]"
                :key="item.id"
                :label="$i18n.locale == 'zh' ? item.name : item.en_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('table.adsenseName')">
            <el-input
              :placeholder="$t('common.enterContent')"
              v-model="listQuery.name"
              style="width: 140px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.searchID')">
            <el-input
              :placeholder="$t('common.searchID')"
              v-model="listQuery.ad_zone_id"
              style="width: 140px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row class="search-btns">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="querySearch()"
            >{{ $t("common.search") }}</el-button
          >
        </el-row>
      </el-form>
    </el-card>
    <div class="mb10">
      <el-button type="primary" class="handle-del mr10" @click="handleAdd">{{
        $t("common.addAdsense")
      }}</el-button>
      <el-button
        type="primary"
        class="handle-del mr10"
        @click="handleAddBatch"
        >{{ $t("common.addAdsenseBatch") }}</el-button
      >
    </div>
    <el-card>
      <div class="table-container">
        <div>
          <el-table
            v-if="tableData && tableData.length > 0"
            :data="tableData"
            class="table"
            v-loading="listLoading"
          >
            <el-table-column
              prop="ad_zone_id"
              :label="$t('table.adsenseId')"
              width="270"
              align="left"
            >
              <template slot-scope="scope">
                <div>
                  <div v-if="!scope.row.isEditing">
                    <span>{{ scope.row.ad_zone_id }}</span>
                  </div>
                  <div v-else class="adEditInput">
                    <el-input
                      v-model="scope.row.ad_zone_id"
                      size="small"
                    ></el-input>
                    <el-button
                      size="mini"
                      icon="el-icon-close"
                      circle
                      @click="cancelEdit(scope.$index)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="success"
                      icon="el-icon-check"
                      circle
                      @click="adZoneIdUpdate(scope.row, scope.$index)"
                    ></el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('table.adsenseName')"
              min-width="150"
              align="left"
            ></el-table-column>
            <el-table-column
              prop="application_id"
              :label="$t('table.application')"
              min-width="180"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.application_id | filterAppId(appList) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="flow_type"
              :label="$t('sdk.flowType')"
              align="left"
              width="150"
            >
              <template slot-scope="scope">
                <div style="word-break: keep-all">
                  {{
                    scope.row.flow_type
                      | filterCloumnValue(
                        [
                          ...$com.abroadList.flowTypeOpenAd,
                          ...$com.abroadList.flowTypeList,
                        ],
                        $i18n.locale,
                      )
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="co_mode"
              :label="$t('table.coMode')"
              align="left"
              width="270"
            >
              <template slot-scope="scope">
                {{
                  scope.row.co_mode
                    | filterCloumnValue($com.abroadList.modeList, $i18n.locale)
                }}{{ scope.row.co_mode == 1 ? ": " + scope.row.min_price : "" }}
                <span v-if="scope.row.co_mode == 1">
                  {{ $t("common.meiyuan") }}/cpm</span
                >
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('table.status')"
              align="left"
              width="160"
            >
              <template slot-scope="scope">
                <div style="position: relative">
                  <el-tag :type="statusBtn(scope.row.ap_status).type">
                    {{
                      scope.row.ap_status
                        | filterCloumnValue(
                          $com.abroadList.statusList,
                          $i18n.locale,
                        )
                    }}
                  </el-tag>
                  <el-tooltip
                    v-if="scope.row.ap_status == 3"
                    class="item"
                    effect="dark"
                    :content="scope.row.ap_info"
                    placement="top"
                  >
                    <Icon
                      v-if="scope.row.ap_status == 3"
                      name="info"
                      class="svg-icon info-icon"
                    />
                  </el-tooltip>
                </div>
                <!-- <el-tooltip v-if="scope.row.ap_status == 3" class="item" effect="dark" :content="scope.row.ap_info" placement="top">
                                    <i class="el-icon-info" :style="statusBtn(scope.row.ap_status).color"></i>
                                </el-tooltip> -->
              </template>
            </el-table-column>
            <!-- 最后一次新建/编辑这条广告位的账号邮箱和时间，账号被停用或删除后仍然保留 -->
            <el-table-column :label="$t('table.operator')" min-width="180" show-overflow-tooltip align="left">
              <template slot-scope="scope">{{ scope.row.operator_email || '--' }}</template>
            </el-table-column>
            <el-table-column :label="$t('table.operateTime')" width="160" align="left">
              <template slot-scope="scope">{{ scope.row.updated_at | datetime }}</template>
            </el-table-column>
            <el-table-column
              :label="$t('table.operation')"
              align="left"
              width="90"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="large"
                  @click="handleEdit(scope.$index, scope.row)"
                  >{{ $t("operation.edit") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="nodata">
            <img src="../../../../assets/img/nodata.png" class="nodata_img" />
            <p class="nodata_text">暂无数据</p>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-size="20"
            layout="total, sizes, prev, pager, next"
            :total="itemCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <updateBatch
      v-if="batchVisible"
      :visible="batchVisible"
      @updateVisible="handleBatchVisible"
    ></updateBatch>
  </div>
</template>

<script>
import updateBatch from "./updateBatch";
import util from "@/utils/util";
import { datetime } from "@/utils/subAccount/format";
export default {
  components: { updateBatch },
  data() {
    return {
      batchVisible: false,
      dialogVisible: false,
      listLoading: false,
      title: "",
      listQuery: {
        application_id: null,
        template_id: null,
        co_mode: null,
        name: "",
        ad_zone_id: "",
        page: 1,
        page_size: 20,
      },
      appList: [],
      sourceList: [],
      rowData: {},
      appId: "",
      itemCount: 0,
      tableData: [],
    };
  },
  computed: {
    statusBtn() {
      return function (status) {
        const statusMap = this.$com.abroadList.statusList.reduce(
          (map, item) => {
            map[item.id] = {
              type: item.type,
              color: `color:${item.color}`, // 保持与原格式一致
            };
            return map;
          },
          {},
        );
        return statusMap[status] || { type: "info", color: "color:#909399" };
      };
    },
  },
  filters: {
    filterAppId(val, list) {
      let str = "";
      list.forEach((item) => {
        if (item.id == val) {
          str = item.name;
        }
      });
      return str;
    },
    filterCloumnValue(string, list, flag) {
      return util.filterCloumnValue(string, list, flag);
    },
    datetime,
  },
  activated() {
    this.getData(); // 重新加载数据
  },
  created() {
    this.appId = this.$route.query.id;
    if (this.appId) {
      this.listQuery.application_id = Number(this.appId);
    }
    this.getData();
    // this.getDimList();
    this.getAPPList();
  },
  methods: {
    /* getDimList() {
                this.__getData("dimList", null, res => {
                    // 获取模板
                    this.sourceList = res.template_info
                })
            }, */
    // 获取该媒体下的应用
    getAPPList() {
      let params = {
        page: 1,
        page_size: 1000,
      };
      this.__postData("sspAppList", params, (res) => {
        if (res.code == 1) {
          this.$message.error(res.msg);
        } else {
          this.appList = res.list;
        }
      });
    },
    // 分页导航
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.listQuery.page = 1;
      this.listQuery.page_size = val;
      this.getData();
    },
    // 获取 easy-mock 的模拟数据
    getData() {
      this.listLoading = true;
      let params = util.filterParams(this.listQuery);
      this.__postData("sspPositionList", params, (res) => {
        if (res.list !== null) {
          this.tableData = res.list;
        } else {
          this.tableData = [];
        }
        this.itemCount = res.total;
        this.listLoading = false;
      });
    },
    querySearch() {
      this.listQuery.page = 1;
      this.getData();
    },
    handleView(index, row) {
      this.dialogVisible = true;
      this.title = this.$t("common.lookAdsense");
      this.rowData = JSON.parse(JSON.stringify(row));
    },

    handleEdit(index, row) {
      // this.dialogVisible = true
      // this.title = this.$t('common.editAdsense')
      // this.rowData = JSON.parse(JSON.stringify(row))
      this.$router.push({ path: "/abroad/ad/addAD", query: { id: row.id } });
    },
    handleAdd() {
      // this.dialogVisible = true
      // this.title = this.$t('common.addAdsense')
      this.$router.push("/abroad/ad/addAD");
    },
    // 批量添加广告位
    handleAddBatch() {
      this.batchVisible = true;
    },
    handleBatchVisible(data) {
      this.batchVisible = data;
      this.getData();
    },
    // 点击广告位编辑
    startEdit(rowIndex) {
      this.$set(this.tableData, rowIndex, {
        ...this.tableData[rowIndex],
        isEditing: !this.tableData[rowIndex].isEditing,
        // 复制当前ID到tempId以供编辑，同时保持originalId不变
        ad_zone_id_copy: this.tableData[rowIndex].ad_zone_id,
      });
    },
    // 取消编辑
    cancelEdit(rowIndex) {
      const row = this.tableData[rowIndex];
      row.ad_zone_id = row.ad_zone_id_copy;
      row.isEditing = false;
    },
    // 广告位id修改
    adZoneIdUpdate(row, rowIndex) {
      let params = {
        id: row.id,
        ad_zone_id: row.ad_zone_id,
      };
      this.__postData("updateZoneId", params, (res) => {
        if (res.code == 1) {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        } else {
          this.$message.success("广告位ID修改成功");
          this.$set(this.tableData, rowIndex, {
            ...this.tableData[rowIndex],
            isEditing: false,
          });
          this.getData();
        }
      });
    },
  },
};
</script>

<style scoped>
.table-title {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.btn-status-style {
  padding: 2px;
  vertical-align: middle;
}
.status-text {
  display: inline;
  vertical-align: middle;
}
.info-icon {
  position: absolute;
  top: 8px;
  width: 14px;
  height: 14px;
  vertical-align: baseline;
  margin-left: 10px;
}
.error-tips {
  font-size: 10px;
  color: #ff0000;
}
.adEditInput {
  display: flex;
  justify-content: flex-start;
}
</style>
